export default "__VITE_ASSET__1365bbd2__"